<template>
  <div :style="styleObject">
    <button
      style="display: none"
      type="button"
      class="btn-notification-out-stock-items-modal"
      data-bs-toggle="modal"
      data-bs-target="#modalNotificationOutStockItems"
    ></button>
    <button
      style="display: none"
      type="button"
      class="btn-hide-modal-notification-out-stock-items"
      data-bs-dismiss="modal"
      data-bs-target="#modalNotificationOutStockItems"
    ></button>
    <div
      class="modal fade"
      :class="{ 'mlx-outstock': theme2 }"
      id="modalNotificationOutStockItems"
      tabindex="-1"
      aria-labelledby="modalNotificationLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <!-- KSK034: kiosk theme 2. MOO (isKiosk=false) keeps the markup below unchanged. -->
      <KskModalShell v-if="isKiosk" :width="860" :show-close="false">
        <!-- removeItemOutStock() closes the popup by clicking this. -->
        <div style="display: none" class="btn-close-out-stock-items" data-bs-dismiss="modal"></div>
        <div class="ksk-changed">
          <div class="ksk-changed__head">
            <div class="ksk-changed__icon">
              <span class="material-icons-round">warning_amber</span>
            </div>
            <div>
              <h2 id="modalNotificationLabel" class="ksk-changed__title">{{ $t("kiosk.outOfStock.title") }}</h2>
              <p class="ksk-changed__caption">{{ $t("kiosk.outOfStock.caption") }}</p>
            </div>
          </div>
          <ul class="ksk-changed__list">
            <li v-for="row in kskRows" :key="row.key" class="ksk-changed__row">
              <div class="ksk-changed__thumb">
                <img v-if="row.image" :src="row.image" alt="" />
                <span v-else class="material-icons-round">restaurant</span>
              </div>
              <div class="ksk-changed__info">
                <div class="ksk-changed__name">{{ tName(row.name) }}</div>
                <div class="ksk-changed__meta">
                  {{ $t("kiosk.outOfStock.qty", { qty: row.qty }) }}<template v-if="row.parent">{{ " · " + $t("kiosk.outOfStock.from", { parent: tName(row.parent) }) }}</template>
                </div>
              </div>
              <span class="ksk-changed__pill">{{ $t("kiosk.common.soldOut") }}</span>
            </li>
          </ul>
        </div>
        <template #footer>
          <KskButton block icon="sync" class="ksk-changed__btn" @click="removeItemOutStock()">{{ $t("kiosk.outOfStock.update") }}</KskButton>
        </template>
      </KskModalShell>
      <div v-else class="modal-dialog">
        <div class="modal-content">
          <div
            class="modal-header d-flex justify-content-end"
            style="border: 0; padding: 0.1rem 1rem"
          >
            <div
              style="display: none"
              class="btn-close-out-stock-items"
              data-bs-dismiss="modal"
            >
              &times;
            </div>
          </div>
          <div class="modal-body text-center">
            <div class="text-title" style="text-align: left">
              These items become 'out of stock' and will be removed from your
              cart.
            </div>
            <div
              class="div-order-items"
              v-for="(item, index) in itemSelect"
              :key="index"
              style="align-items: center; display: block; margin-top: 15px"
            >
              <div
                style="width: 100%; align-items: center"
                v-if="item.isCanGet == 1"
              >
                <div class="boxEditQuantity" style="width: 100%; height: auto">
                  <div
                    class="boxEditQuantity"
                    style="text-align: left; height: 100%"
                  >
                    {{ item.stock_enable_balance ? item.quantity - item.stock_balance : item.quantity }} x
                    {{ item.item_name }}
                  </div>
                </div>
              </div>
              <div v-if="item.choice && item.choice_selected">
                <div
                  v-for="(itemChoice, indexChoice) in item.choice_selected
                    .items"
                  :key="indexChoice"
                >
                  <div
                    style="width: 100%; align-items: center"
                    v-if="
                      itemChoice?.item_detail &&
                      itemChoice.item_detail.isCanGet == 1
                    "
                  >
                    <div
                      class="boxEditQuantity"
                      style="width: 100%; height: auto"
                    >
                      <div
                        class="boxEditQuantity"
                        style="text-align: left; height: 100%"
                      >
                        {{
                          itemChoice.item_detail.stock_enable_balance
                            ? item.quantity * itemChoice.qty - itemChoice.item_detail.stock_balance
                            : item.quantity * itemChoice.qty
                        }}
                        x {{ itemChoice.item_detail.item_name }} from Main :
                        {{ item.item_name }}
                      </div>
                    </div>
                  </div>
                  <div v-if="itemChoice.item_detail?.modifier_group">
                    <div
                      v-for="(modifierOption, indexModifierOption) in itemChoice
                        .item_detail.modifier_group"
                      :key="indexModifierOption"
                      style="text-align: left"
                    >
                      <div
                        style="position: relative; display: grid"
                        class="div-items"
                        v-for="(
                          itemModifierOption, indexItemModifierOption
                        ) in modifierOption.items"
                        :key="indexItemModifierOption"
                      >
                        <div
                          v-if="
                            itemModifierOption.isCanGet == 1 &&
                            itemModifierOption.stock_enable_balance
                          "
                          class="item-name"
                          style="width: 100%"
                        >
                          <span
                            >{{
                              item.quantity *
                                itemChoice.qty *
                                itemModifierOption.quantity -
                              itemModifierOption.stock_balance
                            }}
                            x {{ itemModifierOption.item_name }} from Main :
                            {{ item.item_name }}</span
                          >
                        </div>
                        <div
                          v-if="
                            itemModifierOption?.item_in_mog &&
                            itemModifierOption?.item_in_mog?.modifier_group
                          "
                        >
                          <div
                            v-for="(
                              subModifierOption, indexSubModifierOption
                            ) in itemModifierOption.item_in_mog.modifier_group"
                            :key="indexSubModifierOption"
                          >
                            <div
                              v-for="(
                                subItemModifierOption,
                                indexSubItemModifierOption
                              ) in subModifierOption.items"
                              :key="indexSubItemModifierOption"
                            >
                              <div
                                v-if="
                                  subItemModifierOption.isCanGet == 1 &&
                                  subItemModifierOption.stock_enable_balance
                                "
                                class="item-name"
                                style="width: 100%"
                              >
                                <span
                                  >{{
                                    item.quantity *
                                      itemChoice.qty *
                                      itemModifierOption.quantity *
                                      subItemModifierOption.quantity -
                                    subItemModifierOption.stock_balance
                                  }}
                                  x {{ subItemModifierOption.item_name }} from
                                  Main : {{ item.item_name }}</span
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-else
                v-for="(
                  modifierOption, indexModifierOption
                ) in item.modifier_group"
                :key="indexModifierOption"
                style="text-align: left"
              >
                <div
                  style="position: relative; display: grid"
                  class="div-items"
                  v-for="(
                    itemModifierOption, indexItemModifierOption
                  ) in modifierOption.items"
                  :key="indexItemModifierOption"
                >
                  <div
                    v-if="
                      itemModifierOption.isCanGet == 1 &&
                      itemModifierOption.stock_enable_balance
                    "
                    class="item-name"
                    style="width: 100%"
                  >
                    <span
                      >{{
                        item.quantity * itemModifierOption.quantity -
                        itemModifierOption.stock_balance
                      }}
                      x {{ itemModifierOption.item_name }} from Main :
                      {{ item.item_name }}</span
                    >
                  </div>
                  <div
                    v-if="
                      itemModifierOption?.item_in_mog &&
                      itemModifierOption?.item_in_mog?.modifier_group
                    "
                  >
                    <div
                      v-for="(
                        subModifierOption, indexSubModifierOption
                      ) in itemModifierOption.item_in_mog.modifier_group"
                      :key="indexSubModifierOption"
                    >
                      <div
                        v-for="(
                          subItemModifierOption, indexSubItemModifierOption
                        ) in subModifierOption.items"
                        :key="indexSubItemModifierOption"
                      >
                        <div
                          v-if="
                            subItemModifierOption.isCanGet == 1 &&
                            subItemModifierOption.stock_enable_balance
                          "
                          class="item-name"
                          style="width: 100%"
                        >
                          <span
                            >{{
                              item.quantity *
                                itemModifierOption.quantity *
                                subItemModifierOption.quantity -
                              subItemModifierOption.stock_balance
                            }}
                            x {{ subItemModifierOption.item_name }} from Main :
                            {{ item.item_name }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer d-flex justify-content-center">
            <button
              @click="removeItemOutStock()"
              type="button"
              class="btn-close-modal"
            >
              Ok
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "vue3-eventbus";
import $ from "jquery";
import KskModalShell from "@/views/kiosk/components/ui/KskModalShell.vue";
import KskButton from "@/views/kiosk/components/ui/KskButton.vue";
import { translatedName } from "@/i18n/menuTranslate";

export default {
  name: "ExchangeStatus",
  components: {
    KskModalShell,
    KskButton,
  },
  props: {
    message: {
      type: String,
      default: "",
    },
    itemSelect: {
      type: Array,
    },
    // Opt-in theme2 skin, mirroring ModalNotification/ModalConfirm's `theme2`
    // prop. Kiosk keeps the original look by default.
    theme2: {
      type: Boolean,
      default: false,
    },
    // KSK034: kiosk theme-2 skin. MOO keeps its markup.
    isKiosk: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      merchantCode: "",
      branchCode: "",
      cartName: "ORDER_INFO",
      queue: false,
    };
  },
  async created() {
    this.cartName = await this.$store.dispatch("cartName");
    const merchantCode = this.$store.state.merchantCode;
    this.merchantCode = merchantCode ? `/${merchantCode}` : "";
    this.branchCode = this.$store.state.branchCode;
    this.queue = this.$route.query.queue ?? false;

    if (this.queue) {
      this.cartName = this.cartName.replace("ORDER_INFO_", "ORDER_QUEUE_INFO_");
    }
  },
  computed: {
    // KSK034: the same rows (and the same removed quantities) the MOO markup
    // lists, flattened for the kiosk list. Display only.
    kskRows() {
      const rows = [];
      const push = (key, it, qty, parent) =>
        rows.push({ key, name: it.item_name, image: it.image || "", qty, parent });
      const subMods = (key, it, base, parent) => {
        (it?.item_in_mog?.modifier_group || []).forEach((g, gi) =>
          (g.items || []).forEach((sub, si) => {
            if (sub.isCanGet == 1 && sub.stock_enable_balance) {
              push(`${key}-s${gi}-${si}`, sub, base * sub.quantity - sub.stock_balance, parent);
            }
          })
        );
      };
      (this.itemSelect || []).forEach((item, i) => {
        if (item.isCanGet == 1) {
          push(`m${i}`, item, item.stock_enable_balance ? item.quantity - item.stock_balance : item.quantity, "");
        }
        if (item.choice && item.choice_selected) {
          (item.choice_selected.items || []).forEach((choice, ci) => {
            const d = choice?.item_detail;
            if (d && d.isCanGet == 1) {
              push(`m${i}-c${ci}`, d, d.stock_enable_balance ? item.quantity * choice.qty - d.stock_balance : item.quantity * choice.qty, item.item_name);
            }
            (d?.modifier_group || []).forEach((g, gi) =>
              (g.items || []).forEach((mod, mi) => {
                const key = `m${i}-c${ci}-g${gi}-${mi}`;
                if (mod.isCanGet == 1 && mod.stock_enable_balance) {
                  push(key, mod, item.quantity * choice.qty * mod.quantity - mod.stock_balance, item.item_name);
                }
                subMods(key, mod, item.quantity * choice.qty * mod.quantity, item.item_name);
              })
            );
          });
        } else {
          (item.modifier_group || []).forEach((g, gi) =>
            (g.items || []).forEach((mod, mi) => {
              const key = `m${i}-g${gi}-${mi}`;
              if (mod.isCanGet == 1 && mod.stock_enable_balance) {
                push(key, mod, item.quantity * mod.quantity - mod.stock_balance, item.item_name);
              }
              subMods(key, mod, item.quantity * mod.quantity, item.item_name);
            })
          );
        }
      });
      return rows;
    },
    styleObject() {
      const accent =
        this.$store.state.mainThemeColorTheme2 || this.$store.state.color;
      return {
        "--color": this.$store.state.color,
        "--mlx-accent": accent,
        "--mlx-btn": this.$store.state.primaryButtonColorTheme2 || accent,
      };
    },
  },
  methods: {
    tName(source) {
      return translatedName(source);
    },
    removeItemOutStock() {
      $(".btn-close-out-stock-items").click();
      var data = this.itemSelect;

      outerLoop: for (let i = 0; i < data.length; i++) {
        const item = data[i];
        const itemQty = item.quantity;

        // Main Item
        if (item && item.isCanGet === 1) {
          if (item.stock_enable_balance) {
            if (item.stock_balance <= 0) {
              data.splice(i, 1);
              i--;
              continue outerLoop;
            } else {
              if (item.quantity > item.stock_balance) {
                item.isCanGet = 2;
                item.quantity = item.stock_balance;
              }
            }
          } else {
            // Flagged unavailable with no stock-balance data to partially
            // fulfil against (e.g. the item was disabled outright rather
            // than run out of a tracked quantity) — remove it entirely
            // instead of leaving it stuck in the cart still marked
            // unavailable, which also keeps checkout blocked.
            data.splice(i, 1);
            i--;
            continue outerLoop;
          }
        }

        // Choice Item
        if (item.choice) {
          let itemsChoice = item.choice_selected.items ?? [];

          for (let h = 0; h < itemsChoice.length; h++) {
            const itemChoice = itemsChoice[h].item_detail;
            const itemChoiceQty = itemsChoice[h].qty;

            if (itemChoice) {
              if (itemChoice && itemChoice.isCanGet === 1) {
                if (itemChoice.stock_enable_balance) {
                  if (
                    item.quantity * itemChoiceQty >
                    itemChoice.stock_balance
                  ) {
                    data.splice(i, 1);
                    i--;
                    continue outerLoop;
                  }
                } else {
                  // Same as the main-item case above: unavailable with no
                  // stock-balance data to check against — remove it rather
                  // than leaving the cart stuck.
                  data.splice(i, 1);
                  i--;
                  continue outerLoop;
                }
              }

              // Modifier Group
              if (itemChoice && itemChoice?.modifier_group) {
                for (let j = 0; j < itemChoice.modifier_group.length; j++) {
                  const items = itemChoice.modifier_group[j].items;

                  for (let k = 0; k < items.length; k++) {
                    const itemModifier = items[k];

                    if (itemModifier.stock_enable_balance) {
                      if (
                        itemQty * itemChoiceQty * itemModifier.quantity >
                        itemModifier.stock_balance
                      ) {
                        data.splice(i, 1);
                        i--;
                        continue outerLoop;
                      }
                    }

                    if (
                      itemModifier?.item_in_mog &&
                      itemModifier?.item_in_mog?.modifier_group
                    ) {
                      for (
                        let m = 0;
                        m < itemModifier.item_in_mog.modifier_group.length;
                        m++
                      ) {
                        const itemsChild =
                          itemModifier.item_in_mog.modifier_group[m].items;

                        for (let n = 0; n < itemsChild.length; n++) {
                          const itemModifierChild = itemsChild[n];

                          if (itemModifierChild.stock_enable_balance) {
                            if (
                              itemQty *
                                itemChoiceQty *
                                itemModifier.quantity *
                                itemModifierChild.quantity >
                              itemModifierChild.stock_balance
                            ) {
                              data.splice(i, 1);
                              i--;
                              continue outerLoop;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        } else {
          // Modifier Group
          if (item && item?.modifier_group) {
            for (let j = 0; j < item.modifier_group.length; j++) {
              const items = item.modifier_group[j].items;

              for (let k = 0; k < items.length; k++) {
                const itemModifier = items[k];

                if (itemModifier.stock_enable_balance) {
                  if (
                    itemQty * itemModifier.quantity >
                    itemModifier.stock_balance
                  ) {
                    data.splice(i, 1);
                    i--;
                    continue outerLoop;
                  }
                }

                if (
                  itemModifier?.item_in_mog &&
                  itemModifier?.item_in_mog?.modifier_group
                ) {
                  for (
                    let m = 0;
                    m < itemModifier.item_in_mog.modifier_group.length;
                    m++
                  ) {
                    const itemsChild =
                      itemModifier.item_in_mog.modifier_group[m].items;

                    for (let n = 0; n < itemsChild.length; n++) {
                      const itemModifierChild = itemsChild[n];

                      if (itemModifierChild.stock_enable_balance) {
                        if (
                          itemQty *
                            itemModifier.quantity *
                            itemModifierChild.quantity >
                          itemModifierChild.stock_balance
                        ) {
                          data.splice(i, 1);
                          i--;
                          continue outerLoop;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }

      var duplicateObjects = this.mergeItems(data);

      duplicateObjects = duplicateObjects.map((item) => {
        item.price_default = item.price_default_no_modifier_option;
        item.member_price = item.member_price_no_modifier_option;
        var totalPrice = 0;

        if (item.choice) {
          item.choice_selected.items.forEach((itemChoice) => {
            if (
              itemChoice?.item_detail &&
              itemChoice?.item_detail?.modifier_group
            ) {
              itemChoice.item_detail.modifier_group.forEach((group) => {
                group.items.forEach((itemModifier) => {
                  totalPrice =
                    itemModifier.price_default *
                    itemModifier.quantity *
                    itemChoice.qty;

                  item.price_default += totalPrice;
                  item.member_price += totalPrice;

                  if (
                    itemModifier.item_in_mog &&
                    itemModifier.item_in_mog.modifier_group
                  ) {
                    itemModifier.item_in_mog.modifier_group.forEach(
                      (subGroup) => {
                        subGroup.items.forEach((subItemModifier) => {
                          totalPrice =
                            subItemModifier.price_default *
                            subItemModifier.quantity *
                            itemModifier.quantity *
                            itemChoice.qty;

                          item.price_default += totalPrice;
                          item.member_price += totalPrice;
                        });
                      }
                    );
                  }
                });
              });
            }
          });
        } else {
          if (item.modifier_group) {
            item.modifier_group.forEach((group) => {
              group.items.forEach((itemModifier) => {
                totalPrice = itemModifier.price_default * itemModifier.quantity;

                item.price_default += totalPrice;
                item.member_price += totalPrice;

                if (
                  itemModifier.item_in_mog &&
                  itemModifier.item_in_mog.modifier_group
                ) {
                  itemModifier.item_in_mog.modifier_group.forEach(
                    (subGroup) => {
                      subGroup.items.forEach((subItemModifier) => {
                        totalPrice =
                          subItemModifier.price_default *
                          subItemModifier.quantity *
                          itemModifier.quantity;

                        item.price_default += totalPrice;
                        item.member_price += totalPrice;
                      });
                    }
                  );
                }
              });
            });
          }
        }

        return item;
      });

      localStorage.removeItem(this.cartName);
      localStorage.setItem(this.cartName, JSON.stringify(duplicateObjects));
      EventBus.emit("ClearItemsOutStockSuccess");
    },
    mergeItems(items) {
      const mergedItems = [];

      // Helper function to check if two modifier groups are identical
      const areModifierGroupsIdentical = (group1, group2) => {
        if (group1.items.length !== group2.items.length) {
          return false;
        }

        for (let i = 0; i < group1.items.length; i++) {
          const item1 = group1.items[i];
          const item2 = group2.items[i];
          if (item1.id !== item2.id || item1.quantity !== item2.quantity) {
            return false;
          }
        }

        return true;
      };

      items.forEach((item) => {
        let merged = false;
        for (let i = 0; i < mergedItems.length; i++) {
          if (
            mergedItems[i].id === item.id &&
            areModifierGroupsIdentical(
              mergedItems[i].modifier_group[0],
              item.modifier_group[0]
            )
          ) {
            mergedItems[i].quantity += item.quantity;
            merged = true;
            break;
          }
        }
        if (!merged) {
          mergedItems.push({ ...item });
        }
      });

      return mergedItems;
    },
  },
};
</script>

<style scoped>
.modal-dialog {
  top: 50%;
  transform: translate(0, -50%) !important;
  color: black;
}

.btn-close-out-stock-items {
  font-size: 32px !important;
  color: var(--color) !important;
  padding-right: 0 !important;
  cursor: pointer;
}

.btn-close-modal {
  background-color: var(--color) !important;
  border: 1px solid var(--color) !important;
  border-radius: 5px;
  color: #ffffff;
  padding: 5px 30px;
}

.text-title {
  font-weight: bold;
  color: red;
  text-align: center !important;
}

.item-name {
  font-size: 14px !important;
}

/* KSK034 — P17 kiosk "Some items have changed" (theme 2), isKiosk only. */
.ksk-changed__head {
  display: flex;
  align-items: flex-start;
  gap: var(--ksk-space-3);
}
.ksk-changed__icon {
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 88px;
  height: 88px;
  border-radius: 50%;
  background: #fdf0dc;
  color: #b25e00;
}
.ksk-changed__icon .material-icons-round {
  font-size: 48px;
}
.ksk-changed__title {
  margin: 0;
  font-family: var(--ksk-font);
  font-size: var(--ksk-headline-size);
  line-height: var(--ksk-headline-lh);
  font-weight: 700;
  color: var(--ksk-text);
}
.ksk-changed__caption {
  margin: var(--ksk-space-1) 0 0;
  font-size: var(--ksk-body-size);
  line-height: var(--ksk-body-lh);
  color: var(--ksk-text-secondary);
}
.ksk-changed__list {
  display: flex;
  flex-direction: column;
  gap: var(--ksk-space-2);
  max-height: 900px;
  margin: var(--ksk-space-4) 0 0;
  padding: 0;
  list-style: none;
  overflow-y: auto;
}
.ksk-changed__row {
  display: flex;
  align-items: center;
  gap: var(--ksk-space-3);
  padding: var(--ksk-space-2);
  border-radius: var(--ksk-radius-card);
  background: var(--ksk-surface-muted);
}
.ksk-changed__thumb {
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 112px;
  height: 112px;
  border-radius: 20px;
  background: var(--ksk-surface);
  color: var(--ksk-text-secondary);
  overflow: hidden;
}
.ksk-changed__thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: grayscale(0.6);
  opacity: 0.75;
}
.ksk-changed__thumb .material-icons-round {
  font-size: 48px;
}
.ksk-changed__info {
  flex: 1 1 auto;
  min-width: 0;
}
.ksk-changed__name {
  font-size: var(--ksk-item-size);
  line-height: var(--ksk-item-lh);
  font-weight: 600;
  color: var(--ksk-text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ksk-changed__meta {
  margin-top: 4px;
  font-size: var(--ksk-body-size);
  line-height: var(--ksk-body-lh);
  color: var(--ksk-text-secondary);
}
.ksk-changed__pill {
  flex: none;
  padding: 8px 20px;
  border-radius: var(--ksk-radius-pill);
  background: #fde3e2;
  color: var(--ksk-error);
  font-size: var(--ksk-caption-size);
  line-height: var(--ksk-caption-lh);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.ksk-changed__btn {
  flex: 1 1 auto;
}

/* Opt-in theme2 skin, mirroring ModalNotification's mlx-notify card
   (MyCart only — kiosk keeps the original look above untouched). */
.mlx-outstock {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.mlx-outstock .modal-dialog {
  max-width: 22rem;
  margin-left: auto;
  margin-right: auto;
  padding: 0 1rem;
}

.mlx-outstock .modal-content {
  border: none;
  border-radius: 1.25rem;
  box-shadow: 0 20px 40px rgba(25, 28, 30, 0.18);
  overflow: hidden;
}

.mlx-outstock .modal-body {
  padding: 1.75rem 1.25rem 1.5rem;
}

.mlx-outstock .text-title {
  font-size: 1rem;
  line-height: 1.45;
  color: #201a1a !important;
}

.mlx-outstock .modal-footer {
  border-top: none;
  padding: 0 1.25rem 1.5rem;
}

.mlx-outstock .btn-close-modal {
  width: 100%;
  border: none !important;
  border-radius: 9999px;
  background-color: var(--mlx-btn, var(--color)) !important;
  color: #ffffff;
  font-weight: 700;
  font-size: 0.95rem;
  padding: 0.8rem 1rem;
  transition: opacity 0.15s ease, transform 0.15s ease;
}

.mlx-outstock .btn-close-modal:active {
  transform: scale(0.97);
}
</style>
